<template>
	<div class="race-details">
		<hero
			color1="var(--v-accent-base)"
			color2="var(--v-accent-base)"
			class="hero"
		>
			{{ race.name }}
		</hero>
		<div class="left">
			<!-- Race details -->
			<race-details-component
				:race="race"
				class="hide-desktop"
				@snackbar-event="$emit('snackbar-event', $event)"
			></race-details-component>

			<!-- Description of the race -->
			<v-card class="rounded-lg description-card race-details-card">
				<h1>Sobre la carrera</h1>
				<p :class="{ extended: showMore }"><span v-html="race.description"></span></p>

				<div class="card-actions">
					<v-spacer></v-spacer>
					<v-btn
						color="info"
						text
						class="rounded-lg"
						v-if="!showMore"
						@click="showMore = true"
						>Ver más</v-btn
					>
					<v-btn
						color="info"
						text
						class="rounded-lg"
						v-else
						@click="showMore = false"
						>Ver menos</v-btn
					>
				</div>
			</v-card>

			<!-- Card to upload results -->
			<v-card class="rounded-lg results-card" v-if="race.inscribed">
				<div class="race-details-card results-margin-helper">
					<download-route
						:raceId="race.id"
						v-if="race.inscribed"
						class="hide-desktop download-route-card"
					></download-route>

					<h1>Subir resultados</h1>
					<p>
						Podrá subir los resultados tantas veces como desee, pero
						<b
							>solo se tendrán en cuenta los últimos que haya
							subido</b
						>.
					</p>
					<v-file-input
						label="Suba su archivo GPX"
						class="results-input"
						accept=".gpx, application/gpx+xml"
						cleareable
						ref="fileInput"
						@change="resultsUploaded"
					></v-file-input>

					<v-checkbox :rules="accepted" v-model="privacyAccepted">
						<template v-slot:label>
							<span
								>He leído y acepto la

								<a
									href="/politica-privacidad"
									target="_blank"
									@click.stop
									>Política de Privacidad</a
								>
								de CARRERAS KINESIA.</span
							></template
						>
					</v-checkbox>

					<div class="card-actions">
						<v-spacer></v-spacer>
						<v-btn
							class="result-button my-2 rounded-lg"
							elevation="0"
							large
							color="success"
							@click="uploadResults"
							:disabled="!valid || loading || !privacyAccepted"
							:loading="loading"
						>
							Subir resultados
						</v-btn>

						<v-row
							class="ma-0 strava-alert-container"
							v-if="!user.strava"
						>
							<v-spacer></v-spacer>
							<v-alert
								class="mt-4 strava-alert"
								icon="mdi-alert"
								color="#FC4C02"
								colored-border
								border="left"
								elevation="0"
								dense
							>
								<v-row class="ma-0">
									<v-spacer></v-spacer>
									<p class="small" v-if="!user.strava">
										¿Quiere subir sus resultados desde
										Strava? Autorice la aplicación desde
										<router-link
											:to="{ name: 'UserProfile' }"
											>MI PERFIL</router-link
										>
										(<b>solo tendrá que hacerlo una vez</b>)
									</p>
								</v-row>
							</v-alert>
						</v-row>

						<v-dialog v-model="stravaDialog" max-width="1400px">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									class="result-button my-2 rounded-lg"
									elevation="0"
									large
									color="#FC4C02"
									:dark="!loading && user.strava"
									v-bind="attrs"
									v-on="on"
									:disabled="loading || !user.strava"
									:loading="loading"
								>
									Subir desde
									<v-img
										class="mx-1 result-button-image"
										height="18"
										width="86"
										src="../../assets/User/strava_logo_white.png"
										alt="Strava Logo"
									></v-img>
								</v-btn>
							</template>

							<v-card class="rounded-lg strava-activities-card">
								<upload-strava-activity
									@snackbar-event="
										$emit('snackbar-event', $event)
									"
									@uploaded="
										stravaDialog = false;
										fetchRanking();
									"
									@strava-unauthorized="user.strava = false"
									:race="race"
								></upload-strava-activity>
								<v-row class="ma-0 mt-6">
									<v-spacer></v-spacer>
									<v-btn
										text
										class="rounded-lg"
										color="error"
										@click="stravaDialog = false"
										>Cancelar</v-btn
									>
								</v-row>
							</v-card>
						</v-dialog>
					</div>
				</div>

				<div class="privacy-notice">
					<p>
						<b
							>Información básica sobre protección de datos
							(RGPD|LOPD-gdd)
						</b>
						<br /><br />

						Responsable: KINESIA SPORT, S.L ​ <br />

						Finalidad: Recepción, Gestión y tramitación de
						publicación de los datos deportivos obtenidos por los
						usuarios inscritos en las diferentes carreras
						organizadas por el Responsable.​​ <br />

						Legitimación: Consentimiento del interesado.​​ <br />

						Destinatarios: No se cederán datos a terceros, salvo
						obligación legal​. ​ <br />

						Derechos: Acceder, rectificar, limitar y suprimir los
						datos, así como presentar una reclamación ante la
						autoridad nacional de control, como se explica en la
						información adicional.​ ​ <br />

						Información Adicional: Puede consultar la información
						adicional y detallada sobre Protección de Datos en
						nuestra “Política de Privacidad”.​
					</p>
				</div>
			</v-card>

			<v-card class="rounded-lg ranking-card">
				<div class="card-header">
					<h1>Ránking</h1>
				</div>
				<div class="card-main">
					<ranking-component
						:loading="loading"
						:ranking="ranking"
						v-if="user.id"
					></ranking-component>
					<p v-else class="text-center">
						<b>Inicie sesión para ver el ránking</b>
					</p>
				</div>
			</v-card>
		</div>

		<div class="right">
			<v-card
				class="rounded-lg hide-mobile download-route-card"
				v-if="race.inscribed"
			>
				<download-route :raceId="race.id"></download-route>
			</v-card>
			<race-details-component
				:race="race"
				class="hide-mobile"
				@snackbar-event="$emit('snackbar-event', $event)"
			></race-details-component>

			<v-card class="rounded-lg map-card">
				<race-map :route="race.route" class="map"></race-map>
			</v-card>
		</div>
	</div>
</template>

<script>
	import moment from "moment";
	import axios from "axios";

	import RaceMap from "../../components/user/Map";
	import Hero from "../../components/user/race-details/Hero";
	import DownloadRoute from "../../components/user/race-details/DownloadRoute";
	import RaceDetailsComponent from "../../components/user/race-details/RaceDetailsComponent";
	import RankingComponent from "../../components/user/race-details/Ranking";
	import UploadStravaActivity from "../../components/user/race-details/UploadStravaActivity";

	import gpxRteToJs from "../../utils/parse-gpx-route";

	export default {
		name: "RaceDetails",
		components: {
			RaceMap,
			Hero,
			DownloadRoute,
			RaceDetailsComponent,
			RankingComponent,
			UploadStravaActivity,
		},
		data() {
			return {
				race: {},
				ranking: [],
				resultsArray: [],
				rules: {
					notEmpty: (v) =>
						v !== undefined || "El archivo no puede estar vacío",
				},
				valid: false,
				loading: false,
				stravaDialog: false,

				privacyAccepted: false,
				showMore: false,

				accepted: [(v) => v || "Debe aceptar para continuar"],
			};
		},
		filters: {
			formatDate(value) {
				return moment(value).locale("es").format("LLL");
			},
			formatTime(secs) {
				return moment.utc(secs * 1000).format("HH:mm:ss");
			},
		},
		computed: {
			user() {
				return this.$store.getters["user/getUser"];
			},
		},
		methods: {
			/**
			 * Returns the url for the user's avatar
			 */
			getUserAvatar(id) {
				return `${process.env.VUE_APP_BACK_URL}/media/avatars/${id}.jpeg`;
			},
			/**
			 * Fetches the race
			 */
			async fetchRace() {
				this.$emit("loading", true);
				try {
					const response = await axios.get("race", {
						params: {
							id: this.$route.query.id,
						},
					});

					this.race = response.data;
				} catch (error) {
					//If there is any error, inform the user
					let errorToDisplay;

					//If there is an array of errors
					if (error.response.data instanceof Array) {
						errorToDisplay = "";
						error.response.data.forEach((error) => {
							errorToDisplay += `${error}<br />`;
						});
						//If only one error
					} else if (error.response) {
						errorToDisplay = error.response.data;
						//Rest of the cases
					} else {
						errorToDisplay =
							"Ha ocurrido un error, pruebe más tarde por favor";
					}
					this.$emit("snackbar-event", {
						color: "error",
						text: errorToDisplay,
					});
				} finally {
					this.$emit("loading", false);
				}
			},

			/**
			 * Fetches the ranking
			 */
			async fetchRanking() {
				try {
					const response = await axios.get("/race/ranking", {
						params: {
							raceId: this.race.id,
						},
					});
					this.ranking = response.data;
				} catch (error) {
					console.error(error);
				}
			},

			/**
			 * Inscribes the user in the race
			 */
			async inscribeInRace() {
				try {
					this.$emit("loading", true);

					await axios.post("/user/inscription/race", {
						id: this.race.id,
					});

					this.$emit("snackbar-event", {
						color: "success",
						text: "Se ha completado la inscripción en la carrera",
					});

					this.race.inscribed = true;
				} catch (error) {
					//But if it is not possible, redirect the user to the login
					if (error.response && error.response.status === 401) {
						this.$router.push({
							name: "UserLogin",
							params: {
								redirect: this.$route.fullPath,
							},
						});
					} else {
						//In case the server is not working. show an error
						this.$emit("snackbar-event", {
							color: "error",
							text:
								"Ha ocurrido un error, vuelva a intentarlo más tarde",
						});
					}
				} finally {
					this.$emit("loading", false);
				}
			},

			/**
			 * Processes the uploaded file
			 */
			async resultsUploaded(file) {
				try {
					this.loading = true;
					if (file) {
						this.resultsArray = await gpxRteToJs(file, {
							recordedRoute: true,
						});
						this.valid = true;
					} else {
						this.valid = false;
					}
				} catch (error) {
					this.resultsArray = [];
					this.valid = false;
					this.$emit("snackbar-event", {
						color: "error",
						text: "No se puede procesar el archivo GPX introducido",
					});
				} finally {
					this.loading = false;
				}
			},

			/**
			 * Uploads the race results
			 */
			async uploadResults() {
				try {
					this.loading = true;
					this.$emit("loading", true);

					const response = await axios.post("/race/results", {
						raceId: this.race.id,
						resultsArray: this.resultsArray,
					});

					if (response.status === 201) {
						this.$emit("snackbar-event", {
							color: "success",
							text: "Se han subido correctamente los resultados",
						});
					}
				} catch (error) {
					if (error.response && error.response.data) {
						this.$emit("snackbar-event", {
							color: "error",
							text: error.response.data,
						});
					} else {
						this.$emit("snackbar-event", {
							color: "error",
							text:
								"No se han podido subir los resultados, por favor contacte con nosotros",
						});
					}
				} finally {
					this.fetchRanking();
					this.loading = false;
					this.$emit("loading", false);
				}
			},
		},
		async mounted() {
			this.$vuetify.goTo(0);
			await this.fetchRace();
			await this.fetchRanking();

			if (this.$route.params.checkPayment) {
				if (this.race.inscribed) {
					this.$emit("snackbar-event", {
						color: "success",
						text: "Se ha completado el pago correctamente",
					});
				} else {
					this.$emit("snackbar-event", {
						color: "error",
						text:
							"No se ha completado el pago, si cree que es un error, por favor contacte con nosotros",
					});
				}
			}
		},
	};
</script>

<style lang="scss" scoped>
	@import "../../scss/_mixins.scss";
	@import "../../scss/_variables.scss";

	.race-details {
		height: 100%;
		width: 100%;

		display: flex;
		flex-wrap: wrap;
		justify-content: space-evenly;

		background-color: #f0f0f3;
		padding: 2em 0.5em 0.5em 0.5em;

		@include desktop() {
			padding: 2em;
		}

		.hero {
			margin-bottom: 2em;
		}

		.download-route-card {
			margin-bottom: 2em;

			&.hide-mobile {
				padding: 2em;
			}

			&.hide-desktop {
				margin-bottom: 2em;
			}
		}

		.race-details-card {
			padding: 2em;
			margin-bottom: 2em;

			&.results-margin-helper {
				margin: 0;
			}

			h1 {
				margin-bottom: 0.6em;
			}

			p {
				margin: 0;
				text-align: justify;
				font-size: 1.1em;
				line-height: 1.8em;
			}

			.card-actions {
				margin-top: 2em;
				display: flex;
				flex-wrap: wrap;
			}
		}

		.ranking-card {
			margin-bottom: 2em;

			.card-header {
				display: flex;
				flex-wrap: wrap;
				align-items: center;
				margin: 0;
				padding: 2em;
				background-color: var(--v-secondary-base);

				h1 {
					flex: 1;
					text-align: center;
					padding: 0 0.5em;
					color: #fff;
					font-size: 2em;

					@include desktop() {
						font-size: 3em;
					}
				}
			}

			.card-main {
				padding: 2em;
			}
		}

		.left {
			width: 100%;
			display: flex;
			flex-direction: column;

			@include desktop() {
				flex: 5;
			}

			.results-card {
				width: 100%;
				margin-bottom: 2em;

				.privacy-notice {
					background-color: #e6e6ec;
					padding: 2em;
					p {
						text-align: justify;
						font-size: 0.7em;
						margin: 0;
					}
				}

				.results-input {
					margin-top: 1em;
				}

				.card-actions {
					width: 100%;
					margin-top: 2em;
					display: flex;
					flex-wrap: wrap;
					justify-content: flex-end;

					.result-button {
						margin-left: 1em;

						.result-button-image {
							transform: translateY(-0.11em);
						}
					}

					.strava-alert-container {
						width: 100%;

						.strava-alert {
							border: 1px solid #fc4c02;
						}
					}
				}
			}

			.description-card {
				margin-bottom: 2em;

				p {
					white-space: pre-wrap;
					overflow: hidden;
					max-height: 33vh;
					min-height: 0;
					transition: all 0.5s cubic-bezier(0, 1, 0, 1);

					&.extended {
						min-height: 100px;
						max-height: 2500em;
						overflow-y: auto;
						transition: max-height 1s ease-in-out;
					}
				}
			}

			.details-card.hide-desktop {
				margin-bottom: 2em;
			}
		}

		.right {
			width: 100%;
			display: flex;
			flex-direction: column;

			@include desktop() {
				margin-top: 0;
				flex: 3;
				margin-left: 2em;
			}

			.map-card {
				position: relative;
				z-index: 0;
				margin-bottom: 4em;
				overflow: hidden;
				height: 60vh;
				padding: 0;
			}
		}
	}

	.strava-activities-card {
		padding: 2em;
	}

	.small {
		font-size: 0.8em !important;

		a {
			font-weight: 700;
		}
	}
</style>

<style lang="scss">
	.ranking-card {
		.v-data-table table tbody td {
			padding: 1em !important;
		}
	}
</style>
